/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import EDIT_FOLDER_PROJECT from "./EDIT_FOLDER_PROJECT";
import DELETE_FOLDER_PROJECT from "./DELETE_FOLDER_PROJECT";
import MOVE_FOLDER_TO_FOLDER from "./MOVE_FOLDER_TO_FOLDER";
import FOLDER_COLLAB from "./FOLDER_COLLAB";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import {
  push_value_project,
  set_value_project,
} from "../../App/actions/projectActions";
import {
  get_folder_list_by_parent_folder_id,
  get_project_list_by_folder_id,
} from "../../App/actions/folderProjectAction";

/*PICTURE*/
import menu_icon from "../../Assets/svg/menu_icon.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const FOLDER_PROJECT_MODE_BOX = ({
  auth,
  project,
  set_value_project,
  push_value_project,
  get_folder_list_by_parent_folder_id,
  get_project_list_by_folder_id,
}) => {
  const [modal_menu, set_modal_menu] = useState(false);
  const [anchor, set_anchor] = useState(null);
  const [folder_id, set_folder_id] = useState("");
  const [folder, set_folder] = useState({});
  const [modal_edit_folder, set_modal_edit_folder] = useState(false);
  const [modal_delete_folder, set_modal_delete_folder] = useState(false);
  const [modal_move_folder, set_modal_move_folder] = useState(false);
  const [modal_folder_collab, set_modal_folder_collab] = useState(false);

  const on_click_folder = (folder_data) => {
    set_value_project({
      key: "folder_project_child_list",
      value: [],
    });
    set_value_project({
      key: "geo_project_list_child",
      value: [],
    });

    const selected_id = folder_data?._id;
    set_value_project({
      key: "folder_id_selected",
      value: selected_id,
    });
    set_value_project({
      key: "folder_object_selected",
      value: folder_data,
    });
    push_value_project({
      key: "folder_object_selected_list",
      value: folder_data,
    });
    push_value_project({
      key: "folder_id_selected_list",
      value: selected_id,
    });
    get_folder_list_by_parent_folder_id({
      folder_parent_id: selected_id,
    });
    get_project_list_by_folder_id({
      folder_id: selected_id,
    });
  };

  const toggle_move_folder = () => {
    set_modal_move_folder(!modal_move_folder);
    set_modal_menu(false);
  };

  const toggle_edit_folder = () => {
    set_modal_edit_folder(!modal_edit_folder);
    set_modal_menu(false);
  };

  const toggle_delete_folder = () => {
    set_modal_delete_folder(!modal_delete_folder);
    set_modal_menu(false);
  };

  const toggle_folder_collab = () => {
    set_modal_folder_collab(!modal_folder_collab);
    set_modal_menu(false);
  };

  const toggle_menu = (event) => {
    if (!event || !event.currentTarget) {
      set_value_project({
        key: "folder_id_selected_collab",
        value: "",
      });
      set_modal_menu(false);
      set_anchor(null);
      set_folder_id("");
      set_folder({});
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const target = event.currentTarget; // Always prefer currentTarget over target
    const folderId = target.id;

    const {
      folder_project_list,
      folder_object_selected_list,
      folder_project_child_list,
    } = project;

    const folder_final_list =
      folder_object_selected_list.length > 0
        ? folder_project_child_list
        : folder_project_list;

    const found_folder = folder_final_list.find(
      (item) => item?._id === folderId,
    );

    if (!found_folder) return;

    set_anchor(target);
    set_folder_id(folderId);
    set_folder(found_folder);
    set_modal_menu(true); // moved to bottom to prevent premature render

    set_value_project({
      key: "folder_id_selected_collab",
      value: folderId,
    });
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const {
    folder_project_list,
    folder_project_child_list,
    folder_id_selected_list,
    loading_item_array,
  } = project;

  //content
  let folder_list_final = [];
  if (folder_id_selected_list.length === 0) {
    folder_list_final = folder_project_list;
  } else {
    folder_list_final = folder_project_child_list;
  }

  const modal_menu_content = (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_menu}
      onClose={() => toggle_menu()}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      style={{ borderRadius: "15px" }}
    >
      <div>
        <button
          className="button margin_bottom button_white"
          onClick={toggle_move_folder}
        >
          {dict?.["Move to folder"]?.[language]}
        </button>
        <br />
        <button
          className="button margin_bottom button_white"
          onClick={toggle_edit_folder}
        >
          {dict?.["Edit"]?.[language]}
        </button>
        <br />
        <button
          className="button margin_bottom button_white"
          onClick={toggle_folder_collab}
        >
          {dict?.["Collaboration"]?.[language]}
        </button>
        <br />
        <button className="button button_white" onClick={toggle_delete_folder}>
          {dict?.["Delete"]?.[language]}
        </button>
      </div>
    </FLOAT_MENU>
  );

  const modal_edit_folder_content = modal_edit_folder && (
    <Modal
      modalSize="small"
      isOpen={modal_edit_folder}
      onClose={toggle_edit_folder}
    >
      <div className="box-body" id="box-body">
        <EDIT_FOLDER_PROJECT
          folder={folder}
          toggle_edit_folder={toggle_edit_folder}
        />
      </div>
    </Modal>
  );

  const modal_delete_folder_content = modal_delete_folder && (
    <Modal
      modalSize="small"
      isOpen={modal_delete_folder}
      onClose={toggle_delete_folder}
    >
      <div className="box-body" id="box-body">
        <DELETE_FOLDER_PROJECT
          folder={folder}
          toggle_delete_folder={toggle_delete_folder}
        />
      </div>
    </Modal>
  );

  const modal_move_folder_content = modal_move_folder && (
    <Modal
      modalSize="medium"
      isOpen={modal_move_folder}
      onClose={toggle_move_folder}
      title={dict?.["Move to folder"]?.[language]}
    >
      <div className="box-body" id="box-body">
        <MOVE_FOLDER_TO_FOLDER
          folder={folder}
          toggle_move_folder={toggle_move_folder}
        />
      </div>
    </Modal>
  );

  const modal_folder_collab_content = modal_folder_collab && (
    <Modal
      modalSize="medium"
      isOpen={modal_folder_collab}
      onClose={toggle_folder_collab}
    >
      <div className="box-body">
        <FOLDER_COLLAB />
      </div>
    </Modal>
  );

  let list_content;

  if (loading_item_array.includes("get_folder_list_by_parent_folder_id")) {
    list_content = (
      <div className="container_light">{dict?.["Loading"]?.[language]} ...</div>
    );
  } else if (folder_list_final.length === 0) {
    list_content = (
      <section
        className="container background_white"
        style={{ height: "100px", width: "200px" }}
      >
        <p className="text_medium sub_color">
          {dict?.["You don't have a folder yet"]?.[language]}
        </p>
      </section>
    );
  } else {
    list_content = (
      <section>
        {folder_list_final.map((folder_item, idx) => {
          return (
            <div
              className={`container_folder background_white background_white ${
                folder_item._id === folder_id ? "outline_blue" : "outline_grey"
              }`}
              key={folder_item._id || idx}
              data-mapid={`clickFolder-${idx}`}
            >
              <table className="full_width">
                <tbody>
                  <tr>
                    <td
                      className="text_left cursor_pointer"
                      onClick={() => on_click_folder(folder_item)}
                    >
                      <p
                        className="text_medium max_one_lines"
                        style={{
                          marginTop: "auto",
                          marginBottom: "auto",
                          verticalAlign: "middle",
                        }}
                        title={folder_item?.name}
                      >
                        {folder_item?.name}
                      </p>
                      {folder_item?.groups?.length > 0 && (
                        <div
                          className="badge blue_container margin_left"
                          style={{ verticalAlign: "middle" }}
                        >
                          {dict?.["Group"]?.[language]}
                        </div>
                      )}
                    </td>
                    <td className="text_right" style={{ width: "30px" }}>
                      <button
                        id={folder_item?._id}
                        onClick={toggle_menu}
                        onTouchEnd={toggle_menu} // Use `onTouchEnd` instead of `onTouchStart`
                        className="button button_white"
                      >
                        <img
                          alt="menu"
                          src={menu_icon}
                          height={15}
                          draggable="false"
                        />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        })}
      </section>
    );
  }

  return (
    <main className="margin_bottom">
      {modal_menu_content}
      {modal_move_folder_content}
      {modal_delete_folder_content}
      {modal_edit_folder_content}
      {modal_folder_collab_content}
      <h3 className="text_big margin_bottom">
        {dict?.["Folders"]?.[language]}
      </h3>
      {list_content}
      <hr
        style={{
          width: "100%",
          height: "4px",
          backgroundColor: "#a5a5a5",
          border: "none",
          borderRadius: "4px",
        }}
      />
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, {
  push_value_project,
  set_value_project,
  get_folder_list_by_parent_folder_id,
  get_project_list_by_folder_id,
})(FOLDER_PROJECT_MODE_BOX);
